export default __webpack_public_path__ + "static/media/0011.b2326a56.WAV";